import menuLogo from '../../../assets/menu-logo.svg';
import { ReactComponent as SteeringWheelLogo } from '../../../assets/steering-wheel.svg';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { FLAG_LOAD_ASSIGNMENTS } from '../../../providers/feature-flags-provider/constants';

const menu = {
  menuLogo,
  sidebarOptions: [
    {
      id: 'driver',
      labelStringId: 'driverExperience',
      path: '/driver',
      disabled: false,
      permissions: ['*', 'driver-exp'],
      icon: <SteeringWheelLogo />,
    },
    {
      id: 'load-assignments',
      labelStringId: 'viewSchedule',
      path: '/load-assignments',
      permissions: ['*', 'tickets-view'],
      permissionsSKU: ['deliveries-driver'],
      featureFlag: FLAG_LOAD_ASSIGNMENTS,
      icon: <AssignmentOutlinedIcon />,
    },
    {
      id: 'tickets',
      labelStringId: 'viewTickets',
      path: '/ticket-list',
      permissions: ['*', 'tickets-view'],
      permissionsSKU: ['deliveries-driver'],
      icon: <ReceiptOutlinedIcon />,
    },
    {
      id: 'active-ticket',
      labelStringId: 'viewActiveTicket',
      path: '/active-ticket',
      permissions: ['*', 'tickets-view'],
      permissionsSKU: ['deliveries-driver'],
      icon: <GpsFixedIcon />,
    },
  ],
};

export const getFeatureFlaggedMenuConfig = getFlagValue => ({
  ...menu,
  sidebarOptions: menu?.sidebarOptions?.filter?.(
    option => !option?.featureFlag || getFlagValue?.(option?.featureFlag)
  ),
});

export default menu;
